<template>
  <div class="row">
    <div class="col-lg-9 col-md-12 col-sm-12">
      <div class="pull-left "> <!-- btn-group -->
        <router-link title="Edit" class="btn btn-primary" :to="{ path: '/orders/view/123', params: { id: 123 }}"><i class="ti-arrow-left"></i> Back</router-link>
      </div>
      <p  class="clearfix"></p>
    </div>

    <div class="clearfix"> </div>

    <div class="card col-lg-9 col-md-12 col-sm-12">
      <div class="row">
        <form>

          <div class="card-header"></div>

          <div class="col-md-6 pad-bt-15">
            <div class="row">
              <div class="col-xs-12">
                 <h6><i class="ti-shopping-cart"></i> Order Details</h6>
                 <hr>
              </div>
            </div>
            <div class="row pad-bt-10">
              <div class="col-lg-4 col-sm-5 col-xs-12"><b>Order made at</b></div>
              <div class="col-lg-8 col-sm-7 col-xs-12">{{formatDateTime(order.created_date) }}</div>
            </div>
            <div class="row pad-bt-10">
              <div class="col-lg-4 col-sm-5 col-xs-12 pad-to-10"><b>Order pickup time</b></div>
              <div class="col-lg-8 col-sm-7 col-xs-12">
                <el-time-select class="in-inline" type="time"
                                v-model="order.pickup_time"
                                :value="order.pickup_time"
                                placeholder="">
                      </el-time-select>
              </div>
            </div>
            <div class="row pad-bt-10">
              <div class="col-lg-4 col-sm-5 col-xs-12 pad-to-10"><b>Type</b></div>
              <div class="col-lg-8 col-sm-7 col-xs-12">
                <select name="Payment type" class="form-control" v-model="order.type">
                  <option selected="" disabled="">Select</option>
                  <option value="group" >Group</option>
                  <option value="sigle" >Sigle</option>
                </select>
              </div>
            </div>
            <div class="row pad-bt-10">
              <div class="col-lg-4 col-sm-5 col-xs-12 pad-to-10"><b>Payment</b></div>
              <div class="col-lg-8 col-sm-7 col-xs-12">
                <select name="Payment type" class="form-control" v-model="order.payment.id">
                  <option selected="" disabled="">Select</option>
                  <option value="card" >Card</option>
                  <option value="cash"  >Cash on delivery</option>
                </select>
              </div>
            </div>
            <div class="row pad-bt-10">
              <div class="col-lg-4 col-sm-5 col-xs-12 pad-to-10"><b>Delivery</b></div>
              <div class="col-lg-8 col-sm-7 col-xs-12">
                <select name="Payment type" class="form-control" v-model="order.delivery.id">
                  <option selected="" disabled="">Select</option>
                  <option v-for="del in deliveryMethods" :value="del.id" >{{del.type}}</option>
                </select>
              </div>
            </div>
          </div> <!--  end col-md-12  -->

          <div class="col-md-6 pad-bt-15">
            <div class="row">
              <div class="col-xs-12">
                 <h6><i class="ti-user"></i> Customer Details</h6>
                 <hr>
              </div>
            </div>
            <div class="row pad-bt-10">
              <div class="col-lg-4 col-sm-5 col-xs-12 pad-to-10"><b>Customer</b></div>
              <div class="col-lg-8 col-sm-7 col-xs-12">
                <el-select name="customer"  v-model="order.customer.id" filterable >
                  <el-option selected="" disabled="">Select</el-option>
                  <el-option v-for="cust in customers" :value="cust.id" :key="cust.id" :label="cust.name" >{{cust.name}}</el-option>
                </el-select>
              </div>
            </div>
          </div> <!--  end col-md-12  -->

          <div class="clearfix"> </div>

          <div v-for="address in order.address" class="col-md-6 pad-bt-15">
            <h6><i class="ti-world"></i> {{address.type | capitalize}} Address</h6>
            <hr>
            <div class="row">
              <div class="col-sm-12 pad-bt-10">
                <input type="text"
                 v-model="address.street"
                 v-validate="modelValidations.street"
                 name="street"
                 placeholder="Street"
                 class="form-control">
              </div>
              <div class="col-sm-12 pad-bt-10">
                <input type="text"
                 v-model="address.city"
                 v-validate="modelValidations.city"
                 name="city"
                 placeholder="City"
                 class="form-control">
              </div>
              <div class="col-md-6 col-sm-12 pad-bt-10">
                <select @change="updateCounty(address.type)" v-model="address.country"
                  v-validate="modelValidations.country"
                  name="country"
                  class="select-primary form-control">
                  <option v-for="country in countries"
                          class="select-primary"
                          :value="country">{{country.name}}
                  </option>
                </select>
              </div>
              <div class="col-md-6 col-sm-12 pad-bt-10">
                <select v-model="address.state"
                  name="state"
                  class="select-primary form-control">
                  <option selected="" disabled="">Select</option>
                  <option v-for="state in states[address.type]"
                          class="select-primary"
                          :value="state">{{state}}
                  </option>
                </select>
             <!--    <input type="text"
                 v-model="address.state"
                 v-validate="modelValidations.state"
                 name="state"
                 placeholder="County"
                 class="form-control"> -->
               </div>
            </div>
          </div>

          <div class="col-md-12 pad-bt-15">
            <h6><i class="ti-comment"></i> Customer Comments</h6>
            <hr>
            <textarea class="form-control" v-model="order.comments"> </textarea>
          </div>

          <div class="clearfix"> </div>

          <div class="col-md-12">
            <div class="text-center"><h4>Products</h4></div>
            <table class="table">
              <thead>
                  <tr>
                    <th>Name</th>
                    <th>Qty</th>
                    <th>Unit Price</th>
                    <th>Total</th>
                    <th></th>
                  </tr>
              </thead>
              <tbody>
                <template v-for="customer in order.products">
                  <tr v-if="order.type=='group'" class="active"><td colspan="5">Customer: {{customer.customer.name}}</td></tr>
                  <tr v-for="prod in customer.items">
                    <td>
                      {{prod.name}}
                      <ul v-id="prod.options">
                        <li v-for="opt in prod.options">
                          {{opt.name}}<span v-if="opt.price>0"> +{{ formatMoneyAmount(opt.price, order.currency) }}</span>
                        </li>
                      </ul>
                      <span class=""><i>{{prod.additional_info}}</i></span>
                    </td>
                    <td>{{prod.quantity}}</td>
                    <td>{{formatMoneyAmount(prod.price, order.currency)}}</td>
                    <td>{{formatMoneyAmount(prod.quantity * prod.price, order.currency)}}</td>
                    <td><a title="Remove" class="ti-close text-danger"></a></td>
                  </tr>
                </template>
                <template v-for="(total, label) in order.totals">
                  <tr :class="getRowClass(label)">
                    <td style="border-top:0px solid black"></td>
                    <td style="border-top:0px solid black"></td>
                    <td><b>{{label | capitalize}}</b></td>
                    <td><b>{{formatMoneyAmount(total, order.currency)}}</b></td>
                    <td></td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>

          <div class="col-md-12 pad-to-15">
            <h6><i class="ti-plus"></i> ADD PRODUCT(S)</h6>
            <hr />
          </div>
          <div class="col-sm-3">
            <div class="form-group">
              <label class="control-label"> Person</label>
              <input class="form-control"
                     type="text"
                     name="person"
                     v-validate="modelValidations.person"
                     v-model="modelProduct.person"
                     placeholder=""
              />
            </div>
          </div>
          <div class="col-sm-3">
            <div class="form-group">
              <label class="control-label">
                Product
              </label>
              <select name="product"
                      v-validate="modelValidations.product"
                      v-model="modelProduct.product"
                      class="form-control">
                <option selected="" disabled="">- products -</option>
                <option v-for="prod in productsAll"
                        ref="productOpt"
                        :value="prod.product_id"
                        >{{prod.name}}</option>
              </select>

            </div>
          </div>
          <div class="col-sm-3">
            <div class="form-group">
              <label class="control-label">Quantity</label>
              <input class="form-control"
                     type="number"
                     name="quantity"
                     value="1"
                     v-model="modelProduct.quantity"
                     placeholder=""
              />
            </div>
          </div>

          <div class="col-sm-3 pad-to-5">
            <label> </label><br/>
            <button class="btn btn-info " @click.prevent="addProduct()">Add</button>
          </div>

          <div class="clearfix"> </div>

          <div class="col-md-12 col-sm-12 pad-to-15">
            <h6>% Apply coupon</h6>
            <hr />
          </div>
          <div class="col-sm-12 pad-bt-15">
            <div class="form-group">
              <label class="control-label">Coupon code</label>
              <div class="row">
                <div class="col-sm-3">
                  <input class="form-control"
                         type="text"
                         name="person"
                         v-validate="modelValidations.person"
                         v-model="modelProduct.person"
                         placeholder=""
                  />
                </div>
                <div class="col-sm-3">
                  <button class="btn btn-info " @click.prevent="">Apply</button>
                </div>
              </div>

            </div>
          </div>



          <div class="col-md-12 pad-bt-15 pad-to-15">

            <a href="" title="Save" class="btn btn-info"> Update Order</a>
          </div>

          <!-- </div>  -->
          <p class="clearfix"> </p>
        </form>
      </div>
    </div>

    <div class="clearfix"> </div>

  </div>
</template>
<script>
  import Vue from 'vue'
  import {Select, Option, TimeSelect} from 'element-ui'
  import DataTables from 'vue-data-tables'
  import orderData from './order'
  import countriesList from './../Customers/countries'
  import customersList from './../Customers/customers'
  import deliveryList from './../DeliveryService/services'
  import productsData from './../Products/products'
  Vue.use(Select)
  Vue.use(DataTables)
  Vue.use(TimeSelect)
  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      [TimeSelect.name]: TimeSelect
    },
    data () {
      return {
        order: orderData,
        countries: countriesList,
        customers: customersList,
        deliveryMethods: deliveryList,
        productsAll: productsData,
        states: {billing: [], shipping: []},
        modelValidations: {
          required: {
            required: true
          },
          product: {
            required: true
          },
          person: {
            required: true,
            min: 3
          },
          quantity: {
            required: true,
            min: 1
          }
        },
        newOrderHist: {
          'status': '',
          'comment': '',
          'customer_notified': false
        },
        modelProduct: {
          product: '',
          person: '',
          quantity: '1',
          price: 0
        },
        historyTableColumns: [
          {
            prop: 'date',
            label: 'Date',
            minWidth: 100
          },
          {
            prop: 'comment',
            label: 'Comment',
            minWidth: 200
          },
          {
            prop: 'status',
            label: 'Status',
            minWidth: 100
          },
          {
            prop: 'customer_notified',
            label: 'Customer Notified',
            minWidth: 50
          }
        ]
      }
    },
    created () {
      // this.states = this.getCoutryStates(this.order.billing.country)
    },
    methods: {
      getRowClass (label) {
        switch (label) {
          case 'discount': return 'text-danger'
          case 'total': return 'text-info'
          default: return ''
        }
      },
      addOrderHistory () {
        let history = {
          'date': new Date().toJSON().slice(0, 10),
          'status': this.newOrderHist.status,
          'customer_notified': this.newOrderHist.customer_notified ? 'yes' : 'no',
          'comment': this.newOrderHist.comment
        }
        console.warn(this)
        this.historyTableData.push(history)
        this.newOrderHist = {
          'status': '',
          'comment': '',
          'customer_notified': false
        }
      },
      validate () {
        return this.$validator.validateAll()
      },
      addProduct () {
        var valid = this.validate()

        if (!valid) {
          return false
        }

        var items = this.productsAll
        var price = items[ this.modelProduct.product ].price

        // add the product
        let newRow = {
          'customer': {
            'name': this.modelProduct.person
          },
          'items': [
            {
              'product_id': this.modelProduct.product,
              'name': items[ this.modelProduct.product ].name,
              'quantity': this.modelProduct.quantity,
              'price': price,
              'additional_info': '',
              'options': []
            }
          ]
        }
        this.order.products.push(newRow)

        this.modelProduct = {
          product: '',
          person: '',
          quantity: '1',
          price: 0
        }
      },
      updateCounty (type) {
        // update
        var name = this.order.address[type].country.name
        console.warn(type)
        this.states[type] = this.getCoutryStates(name)
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Orders/OrderEdit.vue